"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableFieldContext = void 0;
const react_1 = require("react");
exports.InlineTableFieldContext = (0, react_1.createContext)({});
//# sourceMappingURL=inline-table-context.js.map